import Swal from "sweetalert2"
import { ADDQUOTATION } from "../../utils/api"
import axios from "../../utils/axios"
import { swalAlertPopProps } from "../../utils/commonUtils"

export const addQuetation=async(payload,callback)=>{
    await axios.post(ADDQUOTATION,payload).then((res)=>{
        

        callback(res)
          if (res?.data?.succeeded) {
                                                Swal.fire({
                                                    title: "Purchase Added Successfully",
                                                    icon: "success",
        
                                                    ...swalAlertPopProps,
                                                });
                                                // getAllData()
                                                // setOpen(false)
                                            }
                                            else {
                                                Swal.fire({
                                                    title: res?.data?.message,
                                                    icon: "error",
        
                                                    ...swalAlertPopProps,
                                                });
                                            }
    })
}